export const success = '#77F511';
export const warning = '#FFC324';
export const critical = '#F45724';
